// extracted by mini-css-extract-plugin
export var phone = "_14-0";